import * as Yup from 'yup';

const requiredMessage = 'Required';

export const schemaValidation = Yup.object().shape({
  firstName: Yup.string().trim().nullable(requiredMessage).required(requiredMessage),
  lastName: Yup.string().trim().nullable(requiredMessage).required(requiredMessage),
  dateOfBirth: Yup.string().trim().nullable(requiredMessage).required(requiredMessage),
  idNumber: Yup.string().trim().nullable(requiredMessage).required(requiredMessage),
  phoneNumber: Yup.string().trim().nullable(requiredMessage).required(requiredMessage),
  email: Yup.string().trim().email('Invalid email'),
});
